import { SALUTE } from '@/constants/constants';

const URLFORMAT = 'DDMMYYYY';
const FRONTFORMAT = 'DD/MM/YYYY';
const SERVERFORMAT = 'YYYY-MM-DD';
const USAGESFORMAT = 'DD-MM-YYYY';
const TELCO_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

const MONTH_NAME_FULL = 'MMMM';
const MONTH_NAME_SHORT = 'MMM';


/** Replaces - for /
 * @param {string} dateString Date string
 * @returns {string} Date with / instead of -
 */
export const changeDashFormatToSlash = (dateString) => {
  if (dateString) {
    return dateString.replace(/-/g, '/');
  }
  return dateString;
};

/** Replaces - for /
 * @param {string} dateString Date string
 * @returns {string} Date with / instead of -
 */
export const changeDateFormat = (dateString, toSlash = true) => {
  if (!dateString) {
    return dateString;
  }
  
  if (toSlash) {
    // Convertir de guiones a barras: 2023-05-06 -> 2023/05/06
    return dateString.replace(/-/g, '/');
  } else {
    // Convertir de barras a guiones: 2023/05/06 -> 2023-05-06
    return dateString.replace(/\//g, '-');
  }
};

/** Replaces - for /
 * @param {string} dateString Date string with front format
 * @returns {string} Date with format "10 de mayo"
 */
export const getJustDateFromDateTime = (dateTime) => {
  const dateString = dateTime.split(' ')[0];

  return `${moment(dateString, USAGESFORMAT).format('D')} de ${moment(dateString, USAGESFORMAT).format(MONTH_NAME_FULL)}`;
};

/** Replaces - for /
 * @param {string} dateString Date string with front format
 * @returns {string} Date with format "10 de dic"
 */
export const getJustDateFromDateTimeShort = (dateTime) => {
  const dateString = dateTime.split(' ')[0];

  return `${moment(dateString, USAGESFORMAT).format('D')} de ${moment(dateString, USAGESFORMAT).format(MONTH_NAME_SHORT)}`;
};

/** Add one month to the dateString pass as argument
 * @param {string} dateString Date string with front format
 * @returns {string} New dateString
 */
export const addOneMonthToDate = (dateString) => moment(dateString, FRONTFORMAT).add(1, 'M').format(FRONTFORMAT);

export const substractOneMonthToDate = (dateString) => moment(dateString, FRONTFORMAT).subtract(1, 'M').format(FRONTFORMAT);

/** Substract one year to the dateString pass as argument
 * @param {string} dateString Date string with front format
 * @returns {string} New dateString
 */
export const substractOneYearToDate = (dateString) => moment(dateString, FRONTFORMAT).subtract(12, 'M').format(FRONTFORMAT);

/** Gets the name of the month of the param
 * @param {string} dateString Date string with front format
 * @returns {string} Month name
 */
export const getMonthName = (dateString) => moment(dateString, FRONTFORMAT).format(MONTH_NAME_FULL);

/** Gets the name of the month of the param
 * @param {string} monthId month id with format YYYYMM
 * @returns {string} Month name
 */
export const getMonthNameByMonthId = (dateString) => moment(dateString, 'YYYYMM').format(MONTH_NAME_FULL);

/** Gets the number of the month of the param
 * @param {string} dateString Date string with front format
 * @returns {string} Month number
 */
export const getMonthNumber = (dateString) => moment(dateString, FRONTFORMAT).format('MM');

export const getDay = (dateString) => moment(dateString, FRONTFORMAT).format('DD');

/** Gets the year of the param
 * @param {string} dateString Date string with front format
 * @returns {string} Year
 */
export const getYear = (dateString) => moment(dateString, FRONTFORMAT).format('YYYY');

/** Transforms the date of the param to obtain the key of the bills array
 * @param {string} dateString Date string with front format
 * @returns {string} Bill array's key
 */
export const getMonthId = (dateString) => {
  if (!dateString) {
    const now = moment().format(FRONTFORMAT);
    return getYear(now) + getMonthNumber(now);
  }
  return getYear(dateString) + getMonthNumber(dateString);
};

/** Gets the short name of the month indicated in the param
 * @param {string} dateString Date string with front format
 * @returns {string} Short month's name
 */
export const getMonthShortName = (dateString) => moment(dateString, FRONTFORMAT).format('MMM').replace('.', '');

/** Changes the welcome message on the header
 * @returns {string} Salute according to daytime
 */
export const getSaluteText = () => {
  if (moment().format('HH') < 14 && moment().format('HH') >= 7) {
    return SALUTE.MORNING;
  }
  if (moment().format('HH') < 20 && moment().format('HH') >= 14) {
    return SALUTE.EVENING;
  }

  return SALUTE.NIGHT;
};

/** Gets the actual date as string
 * @returns {string} Salute according to daytime
 */
export const getActualDateString = () => moment().format(FRONTFORMAT).toString();

/** Changes the date from server format to front format
 * @param {string} dateString Date string with server format
 * @returns {string} Date string with front format
 */
export const changeServerFormatToFrontFormat = (dateString) => moment(dateString, SERVERFORMAT).format(FRONTFORMAT);

/** Changes the date from server format to front format
 * @param {string} dateString Date string with server format
 * @returns {string} Date string with front format
 */
export const changeUsageFormatToFrontFormat = (dateString) => moment(dateString, USAGESFORMAT).format(FRONTFORMAT);

/** Changes the date from server format to front format
 * @param {string} dateString Date string with server format
 * @returns {string} Date string with front format
 */
export const changeTelcoFormatToFrontFormat = (dateString) => moment(dateString, TELCO_FORMAT).format(FRONTFORMAT);

/** Changes the date from front format to server format
 * @param {string} dateString Date string with front format
 * @returns {string} Date string with server format
 */
export const changeFrontFormatToServerFormat = (dateString) => moment(dateString, FRONTFORMAT).format(SERVERFORMAT);

/** Changes the date from front format to URL format
 * @param {string} dateString Date string with front format
 * @returns {string} Date string with URL format
 */
export const changeFrontFormatToUrlFormat = (dateString) => moment(dateString, FRONTFORMAT).format(URLFORMAT);

/** Changes the date from server format to URL format
 * @param {string} dateString Date string with front format
 * @returns {string} Date string with URL format
 */
export const changeServerFormatToUrlFormat = (dateString) => moment(dateString, SERVERFORMAT).format(URLFORMAT);

/** Changes the date from URL format to front format
 * @param {string} dateString Date string with URL format
 * @returns {string} Date string with front format
 */
export const changeUrlFormatToFrontFormat = (dateString) => moment(dateString, URLFORMAT).format(FRONTFORMAT);

/** Changes the date from URL format to server format
 * @param {string} dateString Date string with server format
 * @returns {string} Date string with front format
 */
export const changeUrlFormatToServerFormat = (dateString) => moment(dateString, URLFORMAT).format(SERVERFORMAT);

/** Create a date string with the format (25 de Jul. 2018)
 * @param {string} dateString Date string with front format
 * @returns {string} Date string with "25 de Jul. 2018" format
 */
export const getVerboseDate = (dateString) =>
  `${moment(dateString, FRONTFORMAT).format('D')} de ${moment(dateString, FRONTFORMAT).format('MMM YYYY')}`;

/** Create a date string with the format (Julio 2018)
 * @param {string} dateString Date string with front format
 * @returns {string} Date string with "Julio 2018" format
 */
export const changeSelectedMonthFormatToDisplayFormat = (dateString) =>
  moment(dateString, FRONTFORMAT).format('MMMM YYYY')[0].toUpperCase() + moment(dateString, FRONTFORMAT).format('MMMM YYYY').slice(1);

/** Gets actual date
 * @returns {string} Actual date
 */
export const getActualDate = () => moment();

/** Gets the days left for next bill
 * @param {string} dateString Date string
 * @returns {string} Remaining days for next bill
 */
export const getDaysUntilNextBill = (dateString) => {
  const newDate = changeFrontFormatToServerFormat(dateString);

  const a = moment(newDate).add(1, 'M').format('YYYY-MM-DD');
  const b = moment().format('YYYY-MM-DD');

  return a > b ? ` estará disponible ${moment(newDate).add(1, 'M').format(FRONTFORMAT)}.` : 'aún no está disponible.';
};

/** Gets the days left for received date
 * @param {string} dateString Date string
 * @returns {string} Remaining days left until received date
 */
export const getTimeDifferenceInDays = (dateString) =>
  moment(dateString, FRONTFORMAT).diff(moment(moment().format(FRONTFORMAT), FRONTFORMAT), 'days');

/** Gets the days left for received date
 * @param {string} dateString Date string
 * @returns {string} Remaining days left until received date
 */
export const getTimeDifferenceInYears = (dateString) => moment(dateString, TELCO_FORMAT).diff(moment(), 'years');

/** Changes seconds format
 * @param {string} secondString Seconds string
 * @returns {string} Seconds
 */
export const changeSecondsToDisplayFormat = (seconds) => {
  const minutes = parseInt(seconds / 60, 10);
  const strReturned = `${minutes} min`;
  return strReturned;
};

// h min seg
export const changeSecondsToMinutesFormat = (seconds) => {
  const formatted = moment.utc(seconds * 1000).format('HH:mm:ss');
  const res = formatted.split(':');
  const hours = res[0];
  const min = res[1];
  const seg = res[2];
  const strReturned = hours > 0 ? `${hours} h ${min} min ${seg} seg` : `${min} min ${seg} seg`;
  return strReturned;
};

// h m s
export const changeSecondsToMinutesFormat2 = (seconds) => {
  const formatted = moment.utc(seconds * 1000).format('HH:mm:ss');
  const res = formatted.split(':');
  const hours = res[0];
  const min = res[1];
  const seg = res[2];
  const strReturned = hours > 0 ? `${hours}h ${min}m ${seg}s` : `${min}m ${seg}s`;
  return strReturned;
};

export const dateToHHMM = (date) => {
  return moment(date).format('HH:mm');
};

export const dateToHHMMutc = (date) => {
  return moment.utc(date).format('HH:mm');
};

export const changeTimeToHHMM = (time) => {
  const res = time.split(':');
  const hours = res[0];
  const min = res[1];
  const strReturned = `${hours}:${min}`;
  return strReturned;
};

/** Changes seconds format
 * @param {string} dateString date
 * @param {string} days days less of difference
 * @returns {string} date of difference
 */

export const differenceDate = (dateString, days) => {
  return moment(dateString).subtract(days, 'days');
};

export const changeFrontFormatToMoment = (dateString) => {
  return moment(dateString, FRONTFORMAT);
};

// 2020-01-31T13:58:37.851Z to 31/01/2020

export const changeIsoToFrontFormat = (timeIsoFormat) => {
  const res = moment(timeIsoFormat).format(FRONTFORMAT);
  return res;
};
